__turbopack_context__.v({
  "className": "notosanssc_5d6e142b-module__4Cqf0W__className",
  "variable": "notosanssc_5d6e142b-module__4Cqf0W__variable",
});
